<template lang="pug">
  y-dialog(v-if="showModal" v-model='showModal' scrollable max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4.h6.basic800--text
        v-btn.mr-3(icon small  @click='hasChanges ? confirmClose() : close()')
          v-icon(color="basic800" :size="24") mdi-close
        div(v-if="step === 0") {{ parentProductOptions ? $t('edit') : $t('add') }} {{ $t('product_variant') }}
        div(v-else) {{ $t('set_variant_details') }}
      v-divider.basic300
      v-card-text.pa-0
        v-window(v-model="step")
          //- Product Options settings
          v-window-item(:value="0")
            v-form(ref="formOptions")
              div(v-for="(option, optionIndex) in form.options" :key="`Option-${option.type}-${optionIndex}`" :class="optionIndex > 0 ? 'mt-2' : ''")
                v-container.px-4
                  //- Variant type
                  p.my-3.label.basic600--text.text-uppercase {{ $t('variant_type') }}
                  div.d-flex
                    v-select.mb-4(v-model="selectedOptions[optionIndex]" :items="filteredOptions[optionIndex]" hide-selected background-color="basic200" outlined dense hide-details)
                    v-btn.ml-4.mr-2(icon @click="removeOptionIndex = optionIndex; openDeleteOptionDialog = true")
                      v-icon(color="primary") mdi-minus-circle-outline
                  .others(v-if="selectedOptions[optionIndex] == 'Others'" :class="optionIndex > 0 ? 'mr-16' : ''")
                    v-text-field(v-model="option.name" background-color="basic200" :placeholder="$t('variant_name')" outlined dense :rules="[...rules.not_empty, checkDuplicateOptions]" hide-details="auto")
                  
                  //- Images
                  div.my-3
                    v-row(no-gutters)
                      v-col(cols="9")
                        y-checkbox(v-if="optionIndex === 0" v-model="hasImage" hide-details)
                          template(v-slot:label)
                            div.p1.my-auto {{ $t('add_image_variations') }}
                      v-col.mb-1
                        v-btn(small outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`" @click="rearrangeSpecsTask({ option, optionIndex })")
                          .button-Aa-tiny.primary500--text  {{ $t('rearrange') }}
                  
                  //- Productspecs
                  div.my-3
                    //- List of product specs
                    v-form(ref="specs")
                      template(v-for="(optionSpec, optionSpecIndex) in option.specs")
                        v-card(flat)
                          v-row.mb-3(no-gutters)
                            v-col.mr-3(cols="9")
                              v-text-field(v-model="optionSpec.value" :placeholder="`${option.type}${optionSpecIndex+1}`" background-color="basic200" outlined dense hide-details="auto" :rules="[...rules.not_empty, checkDuplicateSpecs]")
                            v-col.shrink
                              v-btn(v-if="option.specs.length > 1" icon @click="removeSpec = { parentOptionIndex: optionIndex, specIndex: optionSpecIndex }; removeSpecConfirmation()")
                                v-icon(color="primary") mdi-minus-circle-outline
                    //- Add new product variant
                    v-row.mb-3(no-gutters)
                      v-col(cols="9")
                        v-btn.d-flex.justify-start.align-center(@click="form.options[optionIndex].specs.push({ value: '', id: `tmp_${+ new Date()}`, type: 'variant' })" outlined block)
                          v-icon.mr-2(small) mdi-plus
                          .button-Aa-small.primary500--text {{ $t('add') }}
                    
                    //- Option spec image
                    v-row(v-if="optionIndex === 0 && hasImage")
                      v-col(v-for="(spec, specIndex) in previewImages[optionIndex].specs" :key="`${spec.name}-${specIndex}`" cols="4" xl="3")
                        v-card.pa-0(outlined style="border: 1px solid" :height="$vuetify.breakpoint.xs ? '100px' : '125px'" @click="openSpecImages(spec)")
                          v-card-text.text-center.pa-0
                            v-card(v-if="spec.previewImage" flat :height="$vuetify.breakpoint.xs ? '70px' : '95px'")
                              v-img(:src="typeof spec.previewImage.id === 'number' ? spec.previewImage.file : spec.previewImage.fileUrl" aspect-ratio="1" :height="$vuetify.breakpoint.xs ? '70px' : '95px'")
                            v-card.pa-4.d-flex.justify-center.align-center(v-else flat :height="$vuetify.breakpoint.xs ? '70px' : '95px'")
                              v-icon mdi-plus
                            v-divider.basic700
                            .c1.my-1 {{ spec.value }}

                v-divider.basic300(v-if="form.options.length === 1 || optionIndex !== form.options.length-1" style="border:8px solid;")
              //- For adding more option
              div.pa-8.mb-8.d-flex.align-center.clickable(v-if="form.options.length <= 1" @click="addOption")
                v-icon.mr-2 mdi-plus
                .button-Aa-medium.primary500--text {{ $t('add_variant') }}
          //- Product Variant Price, Weight, Stock settings
          v-window-item(:value="1")
            v-container.pa-4
              div.d-flex.align-center.justify-space-between
                .p2.primary500--text {{ $t('set_same_price_weight') }}:
                .button-Aa-small.info500--text.px-2.clickable(@click="openBatchEditDialog = true") {{ $t('batch_edit') }}
            v-row.basic300.text-center(no-gutters)
              v-col.px-4.py-2(:cols="Auth('component', '/admin/products#max_order_quantity') ? '' : 6")
                .s2.basic600--text.text-left {{ $t('price') }}
              v-col.px-4.py-2
                .s2.basic600--text {{ $t('weight') }}
              v-col.px-4.py-2
                .s2.basic600--text {{ $t('stock') }}
              v-col.px-4.py-2(v-if="Auth('component', '/admin/products#max_order_quantity')")
                .s2.basic600--text.text-wrapper {{ $t('order_limit') }}
            v-container.pa-4
              .p2.primary500--text {{ $t('note_leave_stock') }}
            v-divider.basic300(style="border:2px solid;")
            //- Each product specs
            v-form(ref="formProductVariants")
              div(v-for="({ groupName, variants }, groupIndex) in productVariantGrouping" :key="groupName")
                div(v-for="(variant, variantIndex) in variants" :key="variant.computedName")
                  div.px-4
                    .s2.basic700--text.py-2 {{ variant.computedName }}
                    v-divider.basic300.mb-3
                    v-row.text-center(no-gutters)
                      v-col(:cols="Auth('component', '/admin/products#max_order_quantity') ? 4 : 6")
                        v-text-field.mr-2(v-model="variant.product.price" placeholder="0" background-color="basic200" outlined dense type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="hide" @change="hasChanges = true")
                      v-col(:cols="Auth('component', '/admin/products#max_order_quantity') ? 2 : 3")
                        v-text-field(v-model.number="variant.product.weight" background-color="basic200" outlined dense type="number" suffix="kg" hide-details="hide" :rules="setweight ? rules.weight : rules.weight2" @change="hasChanges = true")
                      v-col(cols="3")
                        v-text-field.ml-2(v-model.number="variant.product.inventory_qty" placeholder="#" background-color="basic200" outlined dense type="number" hide-details="hide" @change="hasChanges = true")
                      v-col(cols="3" v-if="Auth('component', '/admin/products#max_order_quantity')")
                        v-text-field.ml-2(v-model.number="variant.product.order_limit" placeholder="#" background-color="basic200" outlined dense type="number" hide-details="hide" @change="hasChanges = true")
                    template(v-if="setdimension")
                      div.p2.basic600--text.my-2 {{ $t('dimension.label') }}
                      div.d-flex
                        v-text-field(v-model.number="variant.product.length" :placeholder="$t('dimension.placeholder_1')" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="hide" :rules="setdimension ? rules.dimension : []" @change="hasChanges = true")
                        div.mt-2.mx-1 X
                        v-text-field(v-model.number="variant.product.width" :placeholder="$t('dimension.placeholder_2')" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="hide" :rules="setdimension ? rules.dimension : []" @change="hasChanges = true")
                        div.mt-2.mx-1 X
                        v-text-field(v-model.number="variant.product.height" :placeholder="$t('dimension.placeholder_3')" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="hide" :rules="setdimension ? rules.dimension : []" @change="hasChanges = true")
                  v-divider.mt-4(:class="variantIndex < variants.length-1 ? 'basic300' : 'transparent'" style="border:1px solid;")
                v-divider(:class="groupIndex < productVariantGrouping.length-1 ? 'basic300' : 'transparent'" style="border:8px solid;")

      v-card-actions.px-4.pb-4.d-flex.justify-end
        template(v-if="step === 0")
          v-btn(v-if="form.options.length > 0" depressed color='textColorAccent' block :disabled="!proceedNext" @click="nextStep")
            .button-AA-medium.basic100--text {{ $t('next_set_variant_details') }}
          v-btn(v-else-if="parentProductOptions" block depressed outlined style="border:1px solid var(--v-primary500)" @click="openDeleteAllOptionDialog = true")
            eva-icon.mr-2(name="trash-2-outline" :fill="$vuetify.theme.themes[$theme].primary500")
            .button-AA-medium.primary500--text {{ $t('remove_variants') }}
        template(v-else)
          v-btn.mr-3(color='textColorAccent' text @click="beforePrevStep")
            .button-Aa-medium.primary400--text {{ $t('back') }}
          v-btn(depressed color='textColorAccent' @click="save")
            .button-AA-medium.basic100--text {{ $t('save_variants') }}
      .modals
        //- Variant rearrange dialog
        rearrange-variant(v-if="openRearrangeDialog" :open.sync="openRearrangeDialog" :parentOption="rearrangeSpecs.option" @updateData="updateRearrangeSpecsTask")
        //- Variant image handling dialog
        manage-product-variant-images(v-if="openManageProductVariantImagesDialog" :open.sync="openManageProductVariantImagesDialog" :parentProduct="parentProduct" :parentSpec="selectedSpec" :tempOptionImages.sync="tempOptionImages" @updateParentSpecImages="updateParentSpecImages")
        //- Delete spec dialog
        y-dialog(v-if="openDeleteSpecDialog" v-model="openDeleteSpecDialog", persistent max-width="320")
          v-card
            v-card-text.p2.primary500--text.pa-6
              div {{ $t('remove_variant_confirmation') }}
               span.font-weight-bold {{ removeSpec.parentOptionName }}: {{ removeSpec.specName }}?
            v-card-actions
              v-spacer
              v-btn(color="white", text @click="removeSpec = null; openDeleteSpecDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color="danger500" depressed height=32 @click="removeSpecTask(); openDeleteSpecDialog = false" dark)
                .button-AA-small.basic100--text {{ $t('remove') }}
        //- Delete option dialog
        y-dialog(v-model='openDeleteOptionDialog', persistent max-width="320")
          v-card
            v-card-text.p2.primary500--text.pa-6
              div {{ $t('remove_variant_group_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color="white", text @click="removeOptionIndex = null; openDeleteOptionDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color="danger500" depressed height=32 @click="removeOption" dark)
                .button-AA-small.basic100--text {{ $t('remove') }}
        //- Delete all options dialog
        y-dialog(v-model='openDeleteAllOptionDialog', persistent max-width="320")
          v-card
            v-card-text.p2.primary500--text.pa-6
              div {{ $t('delete_variants_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color="white", text @click="openDeleteAllOptionDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color="danger500" depressed height=32 @click="removeAllVariants" dark)
                .button-AA-small.basic100--text {{ $t('confirm') }}
        //- Changes not saved dialog
        y-dialog(v-model='openChangesNotSavedDialog', persistent max-width="320")
          v-card
            v-card-title.h6.px-4 {{ $t('changes_not_saved') }}
            v-card-text.p2.primary500--text.px-4
              div {{ $t('discard_changes_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color="white", text @click="openChangesNotSavedDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color="info500" depressed height=32 @click="close" dark)
                .button-AA-small.basic100--text {{ $t('discard_changes') }}
        //- Batch edit dialog
        y-dialog(v-model='openBatchEditDialog', persistent max-width="320")
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('batch_edit_details') }}
            v-divider.basic300
            v-card-text.px-4
              v-row.align-center
                v-col(cols="6")
                  .p1.primary500--text {{ $t('set_all_price_to') }}
                v-col(cols="6")
                  v-text-field(v-model="batchEdit.price" placeholder="0" background-color="basic200" outlined dense type="number" :prefix="$currency.symbol" hide-details="auto")
              v-row.align-center
                v-col(cols="6")
                  .p1.primary500--text {{ $t('set_all_weight_to') }}
                v-col(cols="6")
                  v-text-field(v-model.number="batchEdit.weight" background-color="basic200" outlined dense type="number" suffix="kg" hide-details="auto")
              v-row.align-center
                v-col(cols="6")
                  .p1.primary500--text {{ $t('set_all_stock_to') }}
                v-col(cols="6")
                  v-text-field(v-model.number="batchEdit.inventory_qty" placeholder="#" background-color="basic200" outlined dense type="number" hide-details="auto")
              template(v-if="setdimension")
                v-row.align-center
                  v-col(cols="6")
                    .p1.primary500--text {{ $t('set_all_length_to') }}
                  v-col(cols="6")
                    v-text-field(v-model.number="dimensionBatchEdit.length" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="auto")
                v-row.align-center
                  v-col(cols="6")
                    .p1.primary500--text {{ $t('set_all_width_to') }}
                  v-col(cols="6")
                    v-text-field(v-model.number="dimensionBatchEdit.width" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="auto")
                v-row.align-center
                  v-col(cols="6")
                    .p1.primary500--text {{ $t('set_all_height_to') }}
                  v-col(cols="6")
                    v-text-field(v-model.number="dimensionBatchEdit.height" background-color="basic200" outlined dense type="number" suffix="cm" hide-details="auto")
            v-card-actions
              v-spacer
              v-btn(color="white", text @click="clearBatchEdit(); openBatchEditDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color="textColorAccent" depressed height=32 @click="saveBatchEdit" dark)
                .button-AA-small.basic100--text {{ $t('confirm') }}
</template>

<script>
import clone from 'just-clone'
import draggable from 'vuedraggable'
import ManageProductVariantImages from '@/components/dialogs/ManageProductVariantImages.vue'
import RearrangeVariant from '@/components/dialogs/RearrangeVariant.vue'

export default {
  name: 'AddProductVariantDialog',
  components: {
    draggable,
    ManageProductVariantImages,
    RearrangeVariant
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentProduct: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentProductOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    parentProductVariants: {
      type: Array,
      default: () => {
        return []
      }
    },
    tempRemoveVariants: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tempOptionImages: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setweight: {
      type: Boolean,
      required: true
    },
    setdimension: {
      type: Boolean,
      required: true
    },
    // when user untick the add image to variations checkbox, need to delete all the images
    removeAllVariantImages: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      proceedNext: false,
      step: 0,
      openDeleteOptionDialog: false,
      openBatchEditDialog: false,
      openDeleteAllOptionDialog: false,
      openChangesNotSavedDialog: false,
      openManageProductVariantImagesDialog: false,
      openDeleteSpecDialog: false,
      openRearrangeDialog: false,
      drag: false,
      defaultData: [
        {
          id: null,
          name: 'Color',
          type: 'Color',
          specs: [
            {
              id: `tmp_${+new Date()}`,
              value: 'Black',
              type: 'variant'
            },
            {
              id: `tmp_${+new Date() + 1}`,
              value: 'White',
              type: 'variant'
            }
          ]
        },
        {
          id: null,
          name: 'Size',
          type: 'Size',
          specs: [
            {
              id: `tmp_${+new Date() + 2}`,
              value: 'S',
              type: 'variant'
            },
            {
              id: `tmp_${+new Date() + 3}`,
              value: 'M',
              type: 'variant'
            },
            {
              id: `tmp_${+new Date() + 4}`,
              value: 'L',
              type: 'variant'
            }
          ]
        }
      ],
      othersDefaultData: {
        name: 'Others',
        type: 'Others',
        specs: [
          {
            id: `tmp_${+new Date()}`,
            value: '',
            type: 'variant'
          }
        ]
      },
      form: {
        options: [
          {
            name: null,
            type: null,
            specs: [
              {
                value: null
              }
            ]
          }
        ]
      },
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        selected: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        weight: [v => !!v || 'This field is required', v => v >= 0.1 || 'Weight should not be below 0.1 KG', v => v <= 60 || 'Weight should not be above 60 KG'],
        weight2: [v => !v || v >= 0.1 || 'Weight should not be below 0.1 KG', v => !v || v <= 60 || 'Weight should not be above 60 KG'],
        dimension: [v => !!v || 'This field is required', v => v > 0 || 'measure should not be below 1 cm']
      },
      duplicateError: false,
      options: ['Color', 'Size', 'Others'],
      selectedOptions: [],
      removeOptionIndex: null,
      rearrangeSpecs: null,
      removeSpec: null,
      startChanging: false,
      hasChanges: false, // to indicate any data change
      productVariantGrouping: null,
      batchEdit: {
        price: null,
        weight: null,
        inventory_qty: null,
      },
      dimensionBatchEdit: {
        length: null,
        width: null,
        height: null
      },
      tempProductVariants: null, // temporary save the unsaved product variant for later usage. I know it's crazy init?
      selectedSpec: null,
      selectedPreviewImages: null,
      hasImage: false,
      hasPrimaryImage: false,
      // Snapshot prev temp data (use case : user enter edit variant 2nd time and above)
      prevTempRemoveVariants: null,
      prevTempOptionImages: null
    }
  },
  watch: {
    selectedOptionsCloned(newOptions, prevOptions) {
      // Skip for first time
      if (!this.startChanging) return

      newOptions.forEach((option, index) => {
        // Skip if no changes
        if (option === prevOptions[index]) return
        // Check form options has id (existed option)
        const hasOptionId = !!this.form.options[index].id
        // Change option specs when needed
        switch (option) {
          case 'Color':
            // Check if existed from before, remove old specs and replace with new
            if (hasOptionId) {
              this.form.options[index].specs.forEach(spec => {
                // Check if valid id
                if (typeof spec.id === 'number') {
                  this.tempRemoveVariants.specs.push({
                    parentOptionId: this.form.options[index].id,
                    spec: spec
                  })
                }
              })
            }
            // Replace new options and specs
            this.form.options[index].type = 'Color'
            this.form.options[index].name = 'Color'
            this.form.options[index].specs = [...this.defaultData.filter(data => data.type === 'Color')[0].specs]
            break

          case 'Size':
            // Check if existed from before, remove old specs and replace with new
            if (hasOptionId) {
              this.form.options[index].specs.forEach(spec => {
                // Check if valid id
                if (typeof spec.id === 'number') {
                  this.tempRemoveVariants.specs.push({
                    parentOptionId: this.form.options[index].id,
                    spec: spec
                  })
                }
              })
            }
            // Replace new options and specs
            this.form.options[index].type = 'Size'
            this.form.options[index].name = 'Size'
            this.form.options[index].specs = [...this.defaultData.filter(data => data.type === 'Size')[0].specs]
            break

          // Others data
          default:
            // Check if existed from before, remove old specs and replace with new
            if (hasOptionId) {
              this.form.options[index].specs.forEach(spec => {
                // Check if valid id
                if (typeof spec.id === 'number') {
                  this.tempRemoveVariants.specs.push({
                    parentOptionId: this.form.options[index].id,
                    spec: spec
                  })
                }
              })
            }
            // Replace new options and specs
            this.form.options[index].type = 'Others'
            this.form.options[index].name = null
            this.form.options[index].specs = [...this.othersDefaultData.specs]
            break
        }
      })
    },
    'form.options': {
      deep: true,
      handler(val) {
        // Check for data changes
        if (this.startChanging) this.hasChanges = true
        // Check empty options
        const emptyOptions = val.length === 0
        // Check empty name
        const emptyOptionName = val.filter(option => !option.name).length > 0
        // Check has at least one spec for each options
        const noSpec = val.filter(option => option.specs.length === 0).length > 0
        // Check empty spec value
        let emptySpecsValue = false
        val.forEach(option => {
          option.specs.forEach(spec => {
            if (!spec.value) {
              emptySpecsValue = true
            }
          })
        })
        // Check duplicate specs
        const duplicatedSpecs =
          this.form.options
            .map(option => option.specs.map(spec => spec.value.toLowerCase()))
            .flat()
            .filter((spec, index, arr) => arr.indexOf(spec) != index).length > 0
        // Check duplicate option name

        if (emptyOptions || emptyOptionName || noSpec || emptySpecsValue || duplicatedSpecs) {
          this.proceedNext = false
        } else {
          // Enable proceed
          this.proceedNext = true
        }
      }
    },
    hasImage(val) {
      if (this.startChanging && this.hasPrimaryImage) {
        this.$emit('update:removeAllVariantImages', !val)
        this.hasChanges = true
      }
    },
    previewImages() {
      if (this.startChanging) {
        this.hasChanges = true
      }
    }
  },
  mounted() {
    if (!this.parentProductOptions) {
      // Deep clone data
      this.form.options = clone(this.defaultData)
      this.selectedOptions = ['Color', 'Size']
    } else {
      // Prep data
      const options = this.parentProductOptions.map(option => {
        return {
          ...option,
          type: option.name === 'Color' || option.name === 'Size' ? option.name : 'Others'
        }
      })
      // Deep clone data
      this.form.options = clone(options)
      // Change selectedOptions accordingly
      this.selectedOptions = options.map(option => option.type)
      // Check has image and primary image
      this.form.options.forEach(option => {
        if (option.specs.some(spec => spec.primary_image)) {
          this.hasImage = true
          this.hasPrimaryImage = true
        }
        if (this.tempOptionImages.uploading.length > 0) {
          this.hasImage = true
        }
        if (this.removeAllVariantImages) {
          this.hasImage = false
        }
      })
    }
    // Snapshot prev temp data if any
    this.prevTempOptionImages = clone(this.tempOptionImages)
    this.prevTempRemoveVariants = clone(this.tempRemoveVariants)
    this.$nextTick(() => {
      // skip the first one
      this.startChanging = true
    })
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    // For watch usage
    selectedOptionsCloned() {
      return [...this.selectedOptions]
    },
    availableOptions() {
      return this.options.filter(option => !this.selectedOptions.includes(option)).concat('Others')
    },
    filteredOptions() {
      return this.form.options.map(option => [...new Set(this.availableOptions.concat(option.type))])
    },
    previewImages: {
      cache: false,
      get() {
        return this.form.options.map(option => {
          return {
            name: option.name,
            specs: option.specs.map(spec => {
              const filterUploads = this.tempOptionImages.uploading.filter(image => image.specId === spec.id)
              let uploadingImages = []
              if (filterUploads.length > 0) {
                uploadingImages = [...filterUploads[0].images]
              }
              const filterDelete = this.tempOptionImages.deleting.filter(image => image.specId === spec.id)
              let deletingImages = []
              if (filterDelete.length > 0) {
                deletingImages = [...filterDelete[0].images]
              }
              return {
                ...spec,
                previewImage: spec.images ? spec.images.filter(image => !deletingImages.includes(image.id)).concat(uploadingImages)[0] : spec.primary_image ? spec.primary_image : null
              }
            })
          }
        })
      }
    }
  },
  methods: {
    endMove() {
      this.drag = false
    },
    rearrangeSpecsTask(data) {
      if (!this.$refs.specs[data.optionIndex].validate()) {
        return
      }
      this.rearrangeSpecs = data
      this.openRearrangeDialog = true
    },
    updateRearrangeSpecsTask(data) {
      const { optionIndex } = this.rearrangeSpecs
      this.form.options[optionIndex].specs = clone(data)
    },
    updateParentSpecImages({ specId, images }) {
      this.form.options.forEach(option => {
        option.specs.forEach(spec => {
          if (spec.id === specId) {
            spec.images = images
          }
        })
      })
    },
    openSpecImages(spec) {
      this.selectedSpec = spec
      this.openManageProductVariantImagesDialog = true
    },
    removeSpecConfirmation() {
      const { parentOptionIndex, specIndex } = this.removeSpec
      const toRemove = this.form.options[parentOptionIndex].specs[specIndex]
      if (typeof toRemove.id === 'number') {
        const parentOptionName = this.form.options[parentOptionIndex].name
        const specName = toRemove.value
        this.removeSpec.parentOptionName = parentOptionName
        this.removeSpec.specName = specName
        this.openDeleteSpecDialog = true
      } else {
        this.removeSpecTask()
      }
    },
    removeSpecTask() {
      const { parentOptionIndex, specIndex } = this.removeSpec
      const removed = this.form.options[parentOptionIndex].specs.splice(specIndex, 1)[0]
      if (typeof removed.id === 'number') {
        // Add to temp variants
        this.tempRemoveVariants.specs.push({
          parentOptionId: this.form.options[parentOptionIndex].id,
          spec: removed
        })
        // Remove temp images deleting if any
        this.tempOptionImages.deleting = this.tempOptionImages.deleting.filter(imageGroup => imageGroup.specId !== removed.id)
      } else {
        // Remove temp images uploading if any
        this.tempOptionImages.uploading = this.tempOptionImages.uploading.filter(imageGroup => imageGroup.specId !== removed.id)
      }
    },
    removeOption() {
      this.selectedOptions.splice(this.removeOptionIndex, 1)
      const removed = this.form.options.splice(this.removeOptionIndex, 1)[0]
      if (typeof removed.id === 'number') {
        this.tempRemoveVariants.options.push(removed)
        // Check existing specs and remove if related
        if (this.tempRemoveVariants.specs.length > 0) {
          this.tempRemoveVariants.specs = this.tempRemoveVariants.specs.filter(spec => spec.parentOptionId !== removed.id)
        }
      }
      if (this.removeOptionIndex === 0) {
        this.hasPrimaryImage = false
      }
      this.openDeleteOptionDialog = false
    },
    addOption() {
      let nextOption
      if (this.selectedOptions.includes('Color')) {
        nextOption = {
          value: 'Size',
          index: 1
        }
      } else {
        nextOption = {
          value: 'Color',
          index: 0
        }
      }
      this.selectedOptions.push(nextOption.value)
      const newData = { ...this.defaultData[nextOption.index] }
      newData.specs = [...this.defaultData[nextOption.index].specs]
      this.form.options.push(newData)
    },
    beforePrevStep() {
      this.tempProductVariants = this.productVariantGrouping.map(group => group.variants).flat()
      this.prevStep()
    },
    prevStep() {
      this.step = 0
    },
    nextStep() {
      if (!this.$refs.formOptions.validate()) {
        return
      }
      this.productVariantMapping()
      this.step = 1
      if (this.$refs.formProductVariants) {
        this.$refs.formProductVariants.resetValidation()
      }
    },
    checkDuplicateSpecs(val) {
      if (!val) return true
      // Get all specs values
      const specs = this.form.options.map(option => option.specs.map(spec => spec.value.toLowerCase())).flat()
      return specs.filter(spec => spec === val.toLowerCase()).length === 1 || 'Duplicated name is not allowed'
    },
    checkDuplicateOptions(val) {
      if (!val) return true

      const options = this.form.options.map(option => option.name.toLowerCase())
      return options.filter(option => option === val.toLowerCase()).length === 1 || 'Duplicated name is not allowed'
    },
    productVariantMapping() {
      /** Data Preparation (Support unlimited level of variantions --> Suffered from permanent head damage due to this requirement)
       * Must be in form of array of array (Trust me I'm an engineer)
       * Example
       * [
       *  [
       *    { id: 1, value: 'Black'},
       *    { id: null, value: 'White'}
       *  ],
       *  [
       *    { id: 2, value: 'L' },
       *    { id: 3, value: 'M' },
       *    { id: null, value: 'S'}
       * ], ...]
       *  **/
      const data = []
      this.form.options.forEach(option => {
        data.push(
          option.specs.map(spec => {
            return {
              id: spec.id,
              name: spec.value
            }
          })
        )
      })
      // Matching variant finder, return matched variant if found, else return current variant
      function findMatchingVariant(currentVariant, tempVariants, parentVariants, currencyMultiplier) {
        // Sono mama if no specs
        if (!currentVariant.specs) {
          return currentVariant
        }
        // Let's find one piece!
        let newData = null

        function compareEverySpecs(currentVariant, toCompareVariant) {
          // Need to sort id spec first if both spec id are number (from parent)
          if (toCompareVariant.specs.every(spec => typeof spec === 'number')) {
            toCompareVariant.specs.sort()
          }
          if (currentVariant.specs.every(spec => typeof spec === 'number')) {
            currentVariant.specs.sort()
          }

          return toCompareVariant.specs.every((spec, specIndex) => spec === currentVariant.specs[specIndex])
        }
        // Priority for tempVariants
        const matchedVariant = tempVariants
          ? tempVariants.filter(tempVariant => tempVariant.specs && tempVariant.specs.length === currentVariant.specs.length && compareEverySpecs(currentVariant, tempVariant))
          : parentVariants.filter(parentVariant => parentVariant.specs && parentVariant.specs.length === currentVariant.specs.length && compareEverySpecs(currentVariant, parentVariant))

        if (matchedVariant.length > 0) {
          newData = clone(matchedVariant[0])
          newData.product.price = tempVariants ? newData.product.price : newData.product.price / currencyMultiplier
          newData.product.inventory_qty = newData.product.inventory_enabled ? newData.product.inventory_qty : null
          newData.product.order_limit = newData.product.order_limit_enabled ? newData.product.order_limit : null
          newData.computedName = currentVariant.computedName
          newData.arrayName = currentVariant.arrayName
          delete newData.product.status
          delete newData.product.image
        }

        return newData || currentVariant
      }
      // Mapping process
      this.productVariantGrouping = data.reduce((acc, group) => {
        // Create first main grouping
        if (acc.length === 0) {
          group.forEach(item => {
            let newData = {
              id: null,
              computedName: item.name,
              arrayName: [item.name],
              specs: item.id ? [item.id] : null,
              product: {
                id: null
              }
            }
            if (data.length === 1 && (this.tempProductVariants || this.parentProductVariants)) {
              newData = findMatchingVariant(newData, this.tempProductVariants, this.parentProductVariants, this.$currency.multiplier)
            }
            acc.push({
              groupName: item.name,
              variants: [newData]
            })
          })
        } else {
          acc.forEach(accGroup => {
            // Create new variants data based on prev and current group
            let newData = []
            accGroup.variants.forEach(prevGroupVariant => {
              let newDataArr = group.map(currentGroupVariant => {
                return {
                  id: null,
                  computedName: prevGroupVariant.computedName.concat(', ', currentGroupVariant.name),
                  arrayName: prevGroupVariant.arrayName.concat([currentGroupVariant.name]),
                  specs: currentGroupVariant.id && prevGroupVariant.specs ? prevGroupVariant.specs.concat([currentGroupVariant.id]) : null,
                  product: {
                    id: null
                  }
                }
              })
              if (this.tempProductVariants || this.parentProductVariants) {
                newDataArr = newDataArr.map(currentData => {
                  return findMatchingVariant(currentData, this.tempProductVariants, this.parentProductVariants, this.$currency.multiplier)
                })
              }
              newData.push(newDataArr)
            })
            accGroup.variants = [...newData.flat()]
          })
        }
        return acc
      }, [])
    },
    clearBatchEdit() {
      this.batchEdit.price = null
      this.batchEdit.weight = null
      this.batchEdit.inventory_qty = null,
      this.dimensionBatchEdit.length = null
      this.dimensionBatchEdit.width = null
      this.dimensionBatchEdit.height = null
    },
    saveBatchEdit() {
      if (this.batchEdit.price || this.batchEdit.weight || this.batchEdit.inventory_qty || this.batchEdit.inventory_qty === 0) this.hasChanges = true
      if (this.dimensionBatchEdit.length || this.dimensionBatchEdit.width || this.dimensionBatchEdit.height) this.hasChanges = true
      this.productVariantGrouping.forEach(group => {
        group.variants.forEach(variant => {
          if (this.batchEdit.price) variant.product.price = this.batchEdit.price
          if (this.batchEdit.weight) variant.product.weight = this.batchEdit.weight
          if (this.batchEdit.inventory_qty || this.batchEdit.inventory_qty === 0) variant.product.inventory_qty = this.batchEdit.inventory_qty
          if (this.dimensionBatchEdit.length) variant.product.length = this.dimensionBatchEdit.length
          if (this.dimensionBatchEdit.width) variant.product.width = this.dimensionBatchEdit.width
          if (this.dimensionBatchEdit.height) variant.product.height = this.dimensionBatchEdit.height
        })
      })
      this.openBatchEditDialog = false
      this.clearBatchEdit()
    },
    removeAllVariants() {
      // Remove all options
      this.$emit('removeAllVariants')
      this.showModal = false
    },
    save() {
      if (!this.$refs.formProductVariants.validate()) {
        return
      }
      // Handling images
      if (!this.hasImage) {
        // Reset all temp images
        this.tempOptionImages.uploading = []
      }

      // Map back variants into form
      this.form.variants = this.productVariantGrouping
        .map(group => group.variants)
        .flat()
        .map(variant => {
          const data = {
            ...variant,
            manage_weight: !!variant.product.weight && variant.product.weight > 0,
            manage_dimension: !!variant.product.length && variant.product.length > 0,
            product: {
              ...variant.product,
              price: parseFloat(variant.product.price)
                .toFixed(this.$currency.exponent)
                .replace('.', ''),
              inventory_enabled: variant.product.inventory_qty === '' || variant.product.inventory_qty === null ? false : variant.product.inventory_qty >= 0,
              order_limit_enabled: !!variant.product.order_limit && variant.product.order_limit > 0,
              order_limit: variant.product.order_limit === '' ? 0 : variant.product.order_limit
            }
          }
          // Remove unwanted data
          if (!data.product.inventory_enabled) {
            delete data.product.inventory_qty
          }
          if (!data.product.order_limit_enabled) {
            delete data.product.order_limit
          }
          if (!data.manage_weight) {
            delete data.product.weight
          }
          if (!data.manage_dimension) {
            delete data.product.length
            delete data.product.width
            delete data.product.height
          }
          return data
        })
      this.$emit('updateVariantData', this.form)
      this.showModal = false
    },
    confirmClose() {
      this.openChangesNotSavedDialog = true
    },
    close() {
      // Reset data to previous one
      this.$emit('update:tempOptionImages', clone(this.prevTempOptionImages))
      this.$emit('update:tempRemoveVariants', clone(this.prevTempRemoveVariants))
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.text-wrapper {
  word-break: break-word;
}
.drag-inactive {
  cursor: grab;
}
.drag-active {
  cursor: grabbing;
}
</style>

<i18n>
{
  "en": {
    "add_image_variations": "Add image to variations",
    "set_same_price_weight": "Set same price, weight or stock",
    "note_leave_stock": "Note: Leave stock empty for unlimited products",
    "next_set_variant_details": "Next: Set variant details",
    "remove_variant_confirmation": "Are you sure you want remove variant",
    "remove_variant_group_confirmation": "Are you sure you want remove this variant group?",
    "delete_variants_confirmation": "You are deleting your variants. All set price and stock related to your variants will be discarded. Are you sure?",
    "discard_changes_confirmation": "Do you want to discard the changes?",
    "dimension": {
      "label": "Dimension",
      "placeholder_1": "Length",
      "placeholder_2": "Width",
      "placeholder_3": "Height"
    }
  },
  "id": {
    "add_image_variations": "Tambahkan gambar ke varian",
    "set_same_price_weight": "Tetapkan harga, berat, atau stok yang sama",
    "note_leave_stock": "Nota: Biarkan kosong untuk produk tak terbatas",
    "next_set_variant_details": "Berikutnya: Tetapkan detail varian",
    "remove_variant_confirmation": "Apakah kamu yakin ingin menghapus varian?",
    "remove_variant_group_confirmation": "Yakin ingin menghapus grup varian ini?",
    "delete_variants_confirmation": "Anda menghapus varian kamu. Semua harga dan stok yang ditetapkan terkait dengan varian kamu akan dibuang. Apa kamu yakin?",
    "discard_changes_confirmation": "Apakah kamu ingin membuang perubahan?",
    "dimension": {
      "label": "Dimensi",
      "placeholder_1": "panjang",
      "placeholder_2": "lebar",
      "placeholder_3": "tinggi"
    }
  }
}
</i18n>